/* eslint-disable prefer-template */
import Layout from "../../components/Layout";
import PageTitle from "../../components/PageTitle";
import Button from "../../components/Button";
import useStyles from "./styles";
import { useEffect, useState } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { Icon } from "@iconify/react";
import InputGroup from "../../components/FormComponent/InputGroup";
import ButtonCount from "../../components/ButtonCount";
import Table from "../../components/Table/Table";
import Modal from "../../components/Modal";
import { Gender } from "../../utils/DropDown";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import { TableSearch } from "../../components/Table/TableActions";
import { useNavigate } from "react-router-dom";
import Badge from "../../components/Badge";
import { httprequest } from "../../data/api";
import { toast } from "react-toastify";
import PageLoader from "../../components/PageLoader";
import Select from "react-select";
import useValidator from "../../hooks/useValidator";
import ReactQuill from "react-quill";
import { useUpload } from "../../hooks/useUpload";
import PopModal from "../../components/PopupModal/PopModal";
import CSVExport from "../../components/CsvExport/CsvExport";

const GET_GUARDIAN_ENDPOINT = "/api/v1/guardians";
const CREATE_GUARDIAN_ENDPOINT = "/api/v1/guardian";
const STUDENTS_ENDPOINT = "/api/v1/students";

const Guardian = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [currentRow, setCurrentRow] = useState({});
  const [broadcastModal, setBroadcastModal] = useState(false);
  const [createguardian, setCreateGuardian] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isPageFetching, setIsPageFetching] = useState(false);
  const [guardianData, setGuardianData] = useState([]);
  const [multipleStudents, setMultipleStudents] = useState([]);
  const [guardianValidator, showCreateValidationMessage] = useValidator();
  const [isCreating, setIsCreating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [mailingSelect, setMailingSelect] = useState([]);
  const [selectedGuardians, setSelectedGuardians] = useState([]);
  const [guardianArr, setGuardianArr] = useState([{
    first_name: "",
    last_name: "",
    email: "",
    gender: "",
    contact: "",
    address: "",
    type: "primary"
  }]);
  const [guardianForm, setGuardianForm] = useState({
    wards: multipleStudents, guardians: guardianArr
  });
  const [messageContent, setMessageContent] = useState("");
  const [isSendingMessage, setIsSendingMessage] = useState(false);
  const [selectedMailProvider, setSelectedMailProvider] = useState(null);
  const [subjects, setSubject] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [senderPrefix, setSenderPrefix] = useState("");
  const [senderDomain, setSenderDomain] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [copyModal, setCopyModal] = useState(false);
  const [generatePassword, setGeneratePassword] = useState(false);
  const [createdGuardianCredentials, setCreatedGuardianCredentials] = useState({
    email: "",
    password: ""
  });

  /**
 * Opens the delete confirmation modal for the selected row.
 *
 * @function handleDeleteModal
 * @param {Object} row - The data row to be deleted.
 */
  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  /**
 * Opens the delete confirmation modal for the selected row.
 *
 * @function handleDeleteModal
 * @param {Object} row - The data row to be deleted.
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  const handleCopyModal = () => {
    setCopyModal(!copyModal);
  };

  /**
 * Toggles the broadcast modal visibility.
 *
 * @function handleBroadcastModal
 */
  const handleBroadcastModal = () => {
    setBroadcastModal(!broadcastModal);
  };

  /**
 * Handles input changes for a guardian at a specific index.
 *
 * @function handleChange
 * @param {Event} e - The change event triggered from the input.
 * @param {number} index - Index of the guardian being updated.
 */
  const handleChange = (e, index) => {
    const { value, name } = e.target;
    const allGuardian = [...guardianArr];
    allGuardian[index][name] = value;
    setGuardianArr(allGuardian);
    setGuardianForm({ ...guardianForm, guardians: allGuardian });
  };

  /**
 * Handles setting a guardian as primary or secondary.
 *
 * @function handleIsType
 * @param {Event} e - The change event triggered from the checkbox.
 * @param {number} index - Index of the guardian being updated.
 */
  const handleIsType = (e, index) => {
    const { name, checked } = e.target;
    const allGuardian = [...guardianArr];
    const value = checked && "primary";

    // loop through all the array and set types to secondary
    allGuardian[index][name] = value;
    const updatedGuardian = allGuardian.map((obj, ind) => {
      if (ind !== index) {
        return { ...obj, type: "secondary" };
      }

      return obj;
    });

    setGuardianForm({ ...guardianForm, guardians: updatedGuardian });
  };

  /**
 * Adds a new additional guardian with default values to the form.
 *
 * @function AddAdditionalGuardian
 */

  const AddAdditionalGuardian = () => {
    const newGuardian = {
      first_name: "",
      last_name: "",
      email: "",
      gender: "",
      contact: "",
      address: "",
      type: "secondary"
    };
    setGuardianArr([...guardianArr, newGuardian]);
    setGuardianForm({ ...guardianForm, guardians: [...guardianArr, newGuardian] });
  };

  /**
 * Removes a guardian from the form by index.
 *
 * @function handleDeleteGuardianItem
 * @param {Event} e - The click event.
 * @param {number} index - The index of the guardian to remove.
 */
  const handleDeleteGuardianItem = (e, index) => {
    e.preventDefault();
    const newGuardian = guardianArr.filter((item) => {
      return index !== guardianArr.indexOf(item);
    });

    setGuardianArr(newGuardian);
    setGuardianForm({ ...guardianForm, guardians: newGuardian });
  };

  /**
 * Handles changes in the ward multi-select dropdown.
 *
 * @function handleMultipleWardChange
 * @param {Array} event - Selected ward options.
 */
  const handleMultipleWardChange = (event) => {
    const selectedValue = event.map((item) => item.value);

    setGuardianForm({ ...guardianForm, wards: selectedValue });
  };
  /**
 * Toggles the guardian creation modal open or closed.
 *
 * @function handleSelectGuardian
 */
  const handleSelectGuardian = (e) => {
    const { value } = e.target;
    if (value === "create") {
      setCreateGuardian(!createguardian);
    } else if (value === "batch") {
      navigate("/users/assign-guardian");
    } else if (value === "map") {
      navigate("/users/batch-import-guardian");
    }
  };
  // const handleCreateGuardianModal = () => {
  //   setCreateGuardian(!createguardian);
  // };

  /**
 * Closes the guardian creation modal and clears any form state if needed.
 *
 * @function handleCloseGuardianModal
 */
  const handleCloseGuardianModal = () => {
    setCreateGuardian(false);
  };

  /**
 * Fetches all guardians from the backend.
 *
 * @function getAllGuardian
 */

  const getAllGuardian = () => {
    setIsPageFetching(true);
    httprequest.get(GET_GUARDIAN_ENDPOINT).then((res) => {
      setIsPageFetching(false);
      setGuardianData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setIsPageFetching(false);
      toast.error(err?.response?.data);
    });
  };

  /**
 * Fetches all students and maps them to select dropdown options.
 *
 * @function getAllStudents
 */

  const getAllStudents = () => {
    httprequest.get(STUDENTS_ENDPOINT).then((res) => {
      setMultipleStudents(res?.data?.data?.map((student) => {
        return {
          label: student?.student?.first_name + " " + student?.student?.last_name,
          value: student?.student?.id
        };
      }));
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Validates and submits the guardian form to create a new guardian.
 *
 * @function handleCreateGuardian
 */
  const handleCreateGuardian = () => {
    if (guardianValidator.allValid()) {
      setIsCreating(true);
      const formData = {
        ...guardianForm,
        generate_password: generatePassword
      };
      httprequest.post(CREATE_GUARDIAN_ENDPOINT, formData).then((res) => {
        setIsCreating(false);
        toast.success("Guardian Created and Invite sent successfully");
        getAllGuardian();
        handleCloseGuardianModal();
        if (generatePassword && res.data?.passwords?.length > 0) {
          const passwordData = res.data.passwords[0];
          setCreatedGuardianCredentials({
            email: passwordData.email,
            password: passwordData.password
          });
          setCopyModal(true);
        }
      }).catch((err) => {
        setIsCreating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showCreateValidationMessage(true);
    }
  };

  /**
 * Reactivates a previously deactivated guardian.
 *
 * @function handleReactivateGuardian
 * @returns {Promise<void>}
 */

  const handleReactivateGuardian = async () => {
    setIsDeleting(true);
    try {
      const response = await httprequest.patch(
        `${CREATE_GUARDIAN_ENDPOINT}/${currentRow?.guardian_id}/reactivate`
      );
      toast.success(response?.data?.message);
      handleCloseDeleteModal();
      getAllGuardian();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to reactivate guardian.");
    } finally {
      setIsDeleting(false);
    }
  };

  /**
 * Deletes (or deactivates) a guardian by ID.
 *
 * @function handleDeleteGuardian
 */
  const handleDeleteGuardian = () => {
    setIsDeleting(true);
    httprequest.patch(`${CREATE_GUARDIAN_ENDPOINT}/delete/${currentRow?.guardian_id}`).then((res) => {
      setIsDeleting(false);
      toast.success(res?.data?.message);
      handleCloseDeleteModal();
      getAllGuardian();
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
 * Fetches mailing integration options.
 *
 * @function mallingOption
 */
  const mallingOption = () => {
    httprequest
      .get("/api/v1/integrations/school?category=mail")
      .then((res) => {
        setMailingSelect(res?.data?.data || []);
      })
      .catch(() => {
      });
  };

  // Convert guardian emails into options for the Select component
  const guardianEmailOptions = guardianData?.map((guardian) => ({
    label: `${guardian.first_name} ${guardian.last_name} (${guardian.email})`,
    value: guardian.email,
    name: `${guardian.first_name} ${guardian.last_name}`
  }));

  const handleSelectChange = (selectedOption) => {
    setSelectedGuardians(selectedOption || []);
  };
  useEffect(() => {
    mallingOption();
    getAllGuardian();
    getAllStudents();
  }, []);

  const columns = [
    {
      name: "Guardian Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Guardian</p>}
          {row?.first_name + " " + row?.last_name}
        </>
      )
    },
    {
      name: "Email(s)",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Email(s)</p>}
          {row?.email || "--/--"}
        </>
      )
    },
    {
      name: "Number of wards",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">No of wards</p>}
          {row?.no_of_wards || "--/--"}
        </>
      )
    },
    {
      name: "Contact",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Contact</p>}
          {row?.contact || "--/--"}
        </>
      )
    },
    // {
    //   name: "Type",
    //   center: "true",
    //   cell: (row) => (
    //     <p style={{ display: "flex", flexDirection: "column", margin: 0 }}>
    //       {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Type</p>}
    //       <Badge status={row?.type} />
    //     </p>
    //   )
    // },
    {
      name: "Status",
      center: "true",
      cell: (row) => (<Badge status={row?.is_active} />)
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          {/* <button
            // onClick={() => {
            //   handleAddscoreModal(row);
            // }}
            className="table-action-icon"
          >
            <Icon icon="ic:outline-folder" />
          </button> */}
          <button onClick={() => navigate(`/users/guardians/${row?.guardian_id}`)} className="table-action-icon">
            <Icon icon="codicon:eye" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon"
          >
            {row?.is_active === true ? <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
              : <div className="approve-icon"><Icon icon="mdi:checkbox-marked-circle-outline" /></div>}
          </button>
          <button onClick={() => navigate(`/guardians/password/${row?.guardian_id}`)} className="table-action-icon">
            <Icon icon="material-symbols:key-outline-rounded" />
          </button>
        </div>
      )
    }
  ];

  /**
 * Filters guardians based on name or email input.
 *
 * @function handleSearchStudent
 * @param {Event} e - Input event containing the search value.
 */
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    const filteredByStatus = filterStatus
      ? guardianData.filter((data) => data?.is_active && data?.is_active === filterStatus.toLowerCase())
      : guardianData;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.first_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                          data?.last_name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                          data?.email
                            ?.toLowerCase()
                            .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };
  /**
 * Filters guardian list by their active/inactive status.
 *
 * @function handleFilterChange
 * @param {Event} e - The change event from the filter select input.
 * @returns {void}
 */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Convert the string value to a boolean
    const isActiveFilter = value === "true";

    // Filter guardians based on the is_active status
    const filteredByStatus = value
      ? guardianData.filter((data) => data?.is_active === isActiveFilter)
      : guardianData;

    setSearchResult(filteredByStatus);
  };
  /**
 * Handles file input change for image upload preview.
 *
 * @function handleFileChange
 * @param {Event} e - The file input change event.
 */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);

    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    }
  };

  /**
 * Clears the selected image file and preview.
 *
 * @function handleRemoveImage
 */
  const handleRemoveImage = () => {
    setSelectedFile(null);
    setImagePreview(null);
  };

  /**
 * Handles the selection of a mail provider and sets the sender domain accordingly.
 *
 * @param {Object} selectedProvider - The selected mail provider object from the dropdown.
 */
  const handleMailProviderChange = (selectedProvider) => {
    setSelectedMailProvider(selectedProvider);

    const selectedDomain = mailingSelect.find((option) => option.id === selectedProvider.value)?.domain;

    setSenderDomain(selectedDomain || "");
  };

  /**
 * Updates the message content state when the Quill editor content changes.
 *
 * @param {string} content - The HTML content from the Quill editor.
 */
  const fullSenderEmail = `${senderPrefix}${senderDomain}`;
  const handleQuillChange = (content) => {
    setMessageContent(content);
  };

  /**
 * Sends the message to selected guardians with the selected mailing provider.
 * Validates fields and optionally uploads an attachment before sending.
 */
  const handleSendMessage = async () => {
    if (!selectedGuardians?.length || !selectedMailProvider) {
      toast.error("Please select guardians and a mailing provider.");

      return;
    }
    if (!messageContent.trim()) {
      toast.error("Please enter a message.");

      return;
    }
    const messageForm = {
      to: selectedGuardians.map((guardian) => ({
        email: guardian.value,
        name: guardianEmailOptions.find(option => option.value === guardian.value)?.name // Find the corresponding name
      })),
      integration_id: selectedMailProvider.value,
      from_email: fullSenderEmail,
      from_name: senderPrefix,
      body: messageContent,
      subject: subjects,
      attachment: []
    };

    if (!messageForm.to.length || !messageForm.integration_id || !messageForm.from_email || !messageForm.body || !messageForm.subject) {
      toast.error("Please fill in all required fields.");

      return;
    }

    setIsSendingMessage(true);

    try {
      if (selectedFile) {
        const response = await useUpload(selectedFile);
        if (response.status === 200 && response.data.data) {
          const file_url = response.data.data?.[0]?.file_url;
          messageForm.attachment.push(file_url);
        } else {
          throw new Error("File upload failed.");
        }
      }
      // Send the message
      const result = await httprequest.post("api/v1/message", messageForm, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      toast.success(result?.data?.message);
      handleBroadcastModal();
      setSelectedGuardians([]);
      setSelectedMailProvider(null);
      setSenderPrefix("");
      setMessageContent("");
      setSubject("");
      setSelectedFile(null);
      setIsSendingMessage(false);
    } catch (err) {
      setIsSendingMessage(false);
      toast.error(err?.response?.data?.message || "Failed to send message.");
    }
  };

  /**
 * Prevents dropping of files into the Quill editor.
 *
 * @param {DragEvent} event - The drag-and-drop event.
 */
  const handleEditorDrop = (event) => {
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      // Prevent drop if it's a file (e.g., image)
      event.preventDefault();
      event.stopPropagation();
    }
  };

  /**
 * Prevents pasting of images into the Quill editor.
 *
 * @param {ClipboardEvent} event - The paste event.
 */
  const handlePaste = (event) => {
    const items = event.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      // Check if any pasted item is an image
      if (items[i].type.indexOf("image") !== -1) {
        event.preventDefault(); // Prevent the paste

        return;
      }
    }
  };

  /**
 * Allowed formats for Quill editor. Images and videos are intentionally excluded.
 * @type {string[]}
 */
  const Quillformats = ["background", "bold", "color", "font", "code", "italic", "link", "size",
    "strike", "script", "underline", "blockquote", "header", "indent", "list", "align", "direction", "code-block", "formula"
    // 'image'
    // 'video'
  ];

  /**
 * Navigates to the bulk mails messaging page.
 */
  const messageNavigate = () => {
    navigate("/messaging/bulkmails");
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Guardians"
            subtitle="View all the guardians in your school"
            button={
              <div className="flex gap-10 button_tab">
                <PopModal title="guardian" videoUrl="https://youtu.be/DM5MhnJCmO4" />
                <Button
                  variant="primary"
                  buttonSize="fluid"
                  color="btndefault"
                  onClick={messageNavigate}
                  buttonName="Send Message to parents"
                />
                {/* <Button
                  variant="primary"
                  buttonSize="small"
                  color="btndefault"
                  onClick={handleCopyModal}
                  buttonName="Create Guardian"
                /> */}
                <div className="select-guardian">
                  <SelectGroup
                    children={
                      <select name="type" onChange={handleSelectGuardian}>
                        <option value="">-- Handle Guardian --</option>
                        <option value="create">Create Guardian</option>
                        <option value="batch">Assign Existing Guardian</option>
                        <option value="map">Create Batch Guardian</option>
                      </select>
                    }
                  />
                </div>
              </div>
            }
          />
          <div className="page-content">
            {isPageFetching ? (
              <PageLoader />
            ) : (
              <>
                <div className="button-count-container">
                  <ButtonCount func={() => navigate("")} title="Guardian Count" count={guardianData?.length} />
                </div>
                <Table
                  data={searchResult}
                  columns={columns}
                  subHeader={true}
                  handleRowSelected={({ selectedRows }) => setSelectedRows(selectedRows.map(row => row.guardian_id))}
                  pagination
                  subHeaderComponent={
                    guardianData?.length > 0 && (
                      <div className="action_div">
                        <TableSearch
                          placeholder="Search here..."
                          searchTableFunc={handleSearchStudent}
                        />
                        <div className="text-center gap-10 cursor-pointer">
                          <CSVExport
                            data={guardianData}
                            filename="guardian_export"
                            idKey="guardian_id"
                            selectedRows={selectedRows}
                            fields={[
                              { path: "email", header: "Email Address" },
                              { path: "full_name", header: "Full Name" },
                              { path: "contact", header: "Phone Number" },
                              { path: "no_of_wards", header: "No of wards" },
                              { path: "is_active", header: "Active Status" }
                            ]}
                          />
                          {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                            : <Icon onClick={getAllGuardian} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                          <div>
                            <SelectGroup
                              children={
                                <select name="type" onChange={handleFilterChange}>
                                  <option value="">-- Sort By --</option>
                                  <option value="true">Active</option>
                                  <option value="false">Inactive</option>
                                </select>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    )}
                />
              </>
            )}
          </div>
          {/* Send Broadcast Modal */}
          <Modal
            title="Send Message to parents."
            subtitle={
              <div>Send a message to the parents of the students in this class
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="multiple-select">
                      <p className="input-picker-title">
                      Parents to Message<span className="input-required">*</span>
                      </p>
                      <Select
                        isMulti
                        value={selectedGuardians}
                        onChange={handleSelectChange}
                        options={guardianEmailOptions}
                        placeholder="Select Parents"
                        className="react-select-container"
                        classNamePrefix="react-select"
                      />
                    </div>

                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="multiple-select">
                      <p className="input-picker-title">
                            Select Mailing Provider<span className="input-required">*</span>
                      </p>

                      <Select
                        name="mailing_option"
                        value={selectedMailProvider}
                        onChange={handleMailProviderChange}
                        options={mailingSelect.map((option) => ({
                          label: option.provider,
                          value: option.id
                        }))}
                      />
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={classes.inputwrapper}>
                      <label style={{ display: "flex",
                        flexDirection: "row" }} htmlFor="senderPrefix"
                      >
                        <p style={{
                          color: "#101928",
                          marginBottom: "0px",
                          fontSize: "14px",
                          fontWeight: 500,
                          marginTop: "5px"
                        }}
                        >Sender
                        </p>
                        <span style={{ marginTop: "3px", fontWeight: "500" }} className="input-required">*</span>
                      </label>
                      <div className="gaurdian_input">
                        <input
                          type="text"
                          id="senderPrefix"
                          name="senderPrefix"
                          value={senderPrefix}
                          onChange={(e) => setSenderPrefix(e.target.value.replace(/\s/g, ""))}
                          required
                          placeholder="Sent From"
                        />
                        <input
                          style={{ textAlign: "right" }}
                          value={`${senderDomain}`}
                          disabled
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Subject"
                      margin="normal"
                      placeHolder="Enter Mail Subject"
                      inputType="text"
                      name="subject"
                      value={subjects}
                      onChange={(e) => setSubject(e.target.value)}
                      required
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <p style={{ fontWeight: 500, fontSize: "14px" }} className="text-align-left no-margin-block">
                      Message
                      <span className="input-required">*</span>
                    </p>
                    <ReactQuill
                      theme="snow"
                      value={messageContent}
                      onDrop={handleEditorDrop}
                      onChange={handleQuillChange}
                      onPaste={handlePaste}
                      formats={Quillformats}
                      modules={{
                        toolbar: [
                          [{ "header": [1, 2, false] }],
                          ["bold", "italic", "underline"],
                          [{ "list": "ordered" }, { "list": "bullet" }],
                          ["clean"] // Remove the image button
                        ]
                      }}
                      style={{
                        borderRadius: 30,
                        textAlign: "left",
                        "& qlContainer": { height: "150px" }
                      }}
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={`${classes.label}`}>Additional Information<span className="input-required">*</span></label>
                    <div className={classes.pickercontainer}>
                      {selectedFile ? (
                        <><img style={{ width: "100%", height: "inherit" }} src={imagePreview} />
                          <div
                            className={classes.uploadbuttons}
                            onClick={() => handleRemoveImage()}
                          >
                            <Icon icon="zondicons:minus-solid" /> Remove
                          </div>
                        </>

                      ) : (
                        <>
                          <input type="file" className={classes.picker} onChange={handleFileChange} />

                          <div className={classes.uploadflex}>
                            <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                            <div>
                              <p className={classes.uploadtitle}>Tap to Upload</p>
                              <p className={classes.uploadsubtitle}>SVG, PNG, JPG, GIF | 10MB max.</p>
                            </div>
                          </div>

                          <div className={classes.rightpicker}>
                            <div className={classes.uploadbutton}>Upload</div>
                          </div>
                        </>
                      )}
                    </div>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button onClick={handleBroadcastModal} variant="primaryoutline" buttonSize="full" color="btnfontprimary" buttonName="Cancel" />
                  <Button variant="primary" buttonSize="full" color="btndefault" disabled={isSendingMessage}
                    onClick={handleSendMessage}
                    buttonName={isSendingMessage ? "Sending..." : "Send Message"}
                  />
                </div>
              </>
            }
            isopen={broadcastModal}
            closeModal={handleBroadcastModal}
          />
          {/* Create a Guardian Modal */}
          <Modal
            title="Create Guardian"
            subtitle={
              <div>Create Guardian
              </div>}
            modalContent={
              <>
                <div>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <div className="multiple-select">
                      <p>Wards / Children<span className="input-required">*</span> </p>
                      <Select isMulti name="wards"
                        closeMenuOnSelect={true} options={multipleStudents} onChange={handleMultipleWardChange}
                      />
                    </div>
                    {guardianValidator.message(
                      "wards",
                      guardianForm.wards,
                      "required"
                    )}
                  </Grid>
                  {guardianArr?.map((item, i) => {
                    return (
                      <Grid container spacing={2} className="input-padding" key={i}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label="Guardian First Name"
                            margin="normal"
                            inputType="text"
                            required
                            inputName="first_name"
                            value={item.first_name}
                            onChange={(e) => {
                              handleChange(e, i);
                            }}
                          />
                          {guardianValidator.message(
                            "first_name",
                            guardianArr[i]["first_name"],
                            "required"
                          )}
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label="Guardian Last Name"
                            margin="normal"
                            required
                            inputType="text"
                            inputName="last_name"
                            value={item.last_name}
                            onChange={(e) => {
                              handleChange(e, i);
                            }}
                          />
                          {guardianValidator.message(
                            "last_name",
                            guardianArr[i]["last_name"],
                            "required"
                          )}
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={12}>
                          <SelectGroup required label="Gender" children={
                            <select name="gender" onChange={(e) => handleChange(e, i)}>
                              <option value="">--- Select Gender ---</option>
                              {Gender?.map((label) => {
                                return (
                                  <option key={label.key}>{label.text}</option>
                                );
                              })}
                            </select>
                          }
                          />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label="Email"
                            margin="normal"
                            inputType="email"
                            inputName="email"
                            required
                            value={item.email}
                            onChange={(e) => {
                              handleChange(e, i);
                            }}
                          />
                          {guardianValidator.message(
                            "email",
                            guardianArr[i]["email"],
                            "required|email"
                          )}
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label="Contact"
                            margin="normal"
                            required
                            placeHolder="Enter contact info"
                            inputType="tel"
                            inputName="contact"
                            value={item.contact}
                            onChange={(e) => {
                              handleChange(e, i);
                            }}
                          />
                          {guardianValidator.message(
                            "contact",
                            guardianArr[i]["contact"],
                            "required"
                          )}
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            label="Guardian Address"
                            margin="normal"
                            required
                            placeHolder="Enter Address"
                            inputType="address"
                            inputName="address"
                            value={item.address}
                            onChange={(e) => {
                              handleChange(e, i);
                            }}
                          />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={classes.check}>
                            <input
                              type="checkbox"
                              checked={generatePassword}
                              onChange={(e) => setGeneratePassword(e.target.checked)}
                            />
                            <label className="checkbox-label" htmlFor="">
      Generate password
                            </label>
                          </div>

                        </Grid>

                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <>
                            <input type="radio" name="type" defaultChecked={item?.type === "primary"} id="type" onChange={(e) => {
                              handleIsType(e, i);
                            }}
                            />
                            <label className="checkbox-label" htmlFor="current_term">Primary Guardian</label>
                          </>
                          {guardianValidator.message(
                            "Type",
                            guardianArr[i]["type"],
                            "required"
                          )}
                        </Grid>
                        {guardianArr?.length > 1 && (
                          <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className={`${classes.remove} flex align-items-center`} onClick={(e) => handleDeleteGuardianItem(e, i)}>
                              <Icon icon="zondicons:minus-solid" width="16" height="16" />
                              <p>Remove this Guardian</p>
                            </div>
                          </Grid>
                        )}
                      </Grid>
                    );
                  })}
                  {guardianArr?.length < 2 && (
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <div className={`${classes.addextra} flex align-items-center`} onClick={AddAdditionalGuardian}>
                        <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                        <p>Add Secondary Guardian</p>
                      </div>
                    </Grid>
                  )}
                </div>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Create Guardian" onClick={handleCreateGuardian} isLoading={isCreating} />
                </div>
              </>
            }
            isopen={createguardian}
            closeModal={handleCloseGuardianModal}
          />
          {/* Delete Modal */}
          <Modal
            title={currentRow?.is_active === true ? "Delete Guardian Information" : "Re-activate Guardian information"}
            subtitle={
              currentRow?.is_active === true
                ? (
                  <div>
                    Are you sure you want to delete
                    <span className="modal-name-highlight"> {`${currentRow?.last_name} ${currentRow?.first_name}`}</span>?
                    Deleting is a permanent action
                  </div>
                )
                : (
                  <div>
                    Are you sure you want to re-activate
                    <span className="modal-name-highlight"> {`${currentRow?.last_name} ${currentRow?.first_name}`}</span>?
                    If re-activated, this Guardian will have access to this platform.
                  </div>
                )
            }
            modalContent={
              <>

              </>
            }
            modalFooter={
              <>
                {currentRow?.is_active === true ? <Button variant="danger" isLoading={isDeleting} onClick={handleDeleteGuardian} buttonName="Delete Guardian" buttonSize="full" color="btndefault" />
                  : <Button variant="primary" buttonName="Re-activate Guardian" buttonSize="full" color="btndefault" onClick={handleReactivateGuardian} isLoading={isDeleting} />}
              </>
            }
            isopen={deleteModal}
            closeModal={handleCloseDeleteModal}
          />
          <Modal
            title="Guardian Successfully Created"
            subtitle="Please send to the immediately because you wont be able to see this password again"
            modalContent={
              <div className={classes.copy}>
                <Grid container spacing={2} className={classes.copy_div}>
                  <Grid item lg={6} md={6} sm={12} xs={12}
                    className={classes.details}
                  >
                    <span className={classes.details_span}>Email Address</span>
                    <p className={classes.details_p}>{createdGuardianCredentials.email || "Not available"}</p>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}
                    className={classes.details}
                  >
                    <span className={classes.details_span}>Password</span>
                    <p className={classes.details_p}>{createdGuardianCredentials.password || "Not available"}</p>
                  </Grid>
                </Grid>

                <div className={classes.note}> <Icon icon="fluent:info-16-regular" width="16" height="16" />NB: Copy and send right away, you wont be able to send it after now</div>
              </div>
            }
            modalFooter={
              <>
                <Button variant="primary" buttonName="Copy" buttonSize="full" color="btndefault" onClick={() => {
                  navigator.clipboard.writeText(
                    `Email: ${createdGuardianCredentials.email}\nPassword: ${createdGuardianCredentials.password}`
                  );
                  toast.success("Copied to clipboard!");
                }}
                />
              </>
            }
            isopen={copyModal}
            closeModal={handleCopyModal}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default Guardian;
